export default __webpack_public_path__ + "static/media/shubham.38f8f2be.jpg";